import { render, staticRenderFns } from "./VoucherGeneratorView.vue?vue&type=template&id=280890ac&"
import script from "./VoucherGeneratorView.vue?vue&type=script&lang=js&"
export * from "./VoucherGeneratorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports